// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.deleteChatContent_oMDH4 {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .deleteChatsContainer_YTccu {
    width: 80%;
    background-color: #fff;
    margin: 0 auto;
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    p {
      margin: 0;
      color: #38343d;
    }

    .password_AbEg8 {
      display: flex;
      align-items: center;

      span,
      > div {
        flex: 1 1;
      }

      > div {
        input {
          border: none;
          outline: none;
          font-size: 14px;
          font-weight: 400;
          color: var(--_75-color);
          min-height: 21px;
          background-color: var(--f4-background);
          border-radius: 5px;
          box-sizing: border-box;
          width: 100%;
          padding: 12px;
        }

        span {
          color: #b40e1b;
          font-size: 13px;
        }
        .errorText_S6VcG{
          font-size: 13px;
          color: #b40e1b;
        }
      }
    }
  }
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/ConfirmationWithPasswordPopup/ConfirmationWithPasswordPopup.module.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;;IAET;MACE,SAAS;MACT,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,mBAAmB;;MAEnB;;QAEE,SAAO;MACT;;MAEA;QACE;UACE,YAAY;UACZ,aAAa;UACb,eAAe;UACf,gBAAgB;UAChB,uBAAuB;UACvB,gBAAgB;UAChB,sCAAsC;UACtC,kBAAkB;UAClB,sBAAsB;UACtB,WAAW;UACX,aAAa;QACf;;QAEA;UACE,cAAc;UACd,eAAe;QACjB;QACA;UACE,eAAe;UACf,cAAc;QAChB;MACF;IACF;EACF","sourcesContent":["\n.deleteChatContent {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .deleteChatsContainer {\n    width: 80%;\n    background-color: #fff;\n    margin: 0 auto;\n    padding: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n\n    p {\n      margin: 0;\n      color: #38343d;\n    }\n\n    .password {\n      display: flex;\n      align-items: center;\n\n      span,\n      > div {\n        flex: 1;\n      }\n\n      > div {\n        input {\n          border: none;\n          outline: none;\n          font-size: 14px;\n          font-weight: 400;\n          color: var(--_75-color);\n          min-height: 21px;\n          background-color: var(--f4-background);\n          border-radius: 5px;\n          box-sizing: border-box;\n          width: 100%;\n          padding: 12px;\n        }\n\n        span {\n          color: #b40e1b;\n          font-size: 13px;\n        }\n        .errorText{\n          font-size: 13px;\n          color: #b40e1b;\n        }\n      }\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteChatContent": `deleteChatContent_oMDH4`,
	"deleteChatsContainer": `deleteChatsContainer_YTccu`,
	"password": `password_AbEg8`,
	"errorText": `errorText_S6VcG`
};
export default ___CSS_LOADER_EXPORT___;
